import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ActionSheetController,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import { HomePage } from '../home/home';

/**
 * Generated class for the CommingSoonPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-comming-soon',
  templateUrl: 'comming-soon.html',
})
export class CommingSoonPage {
errorDisplay:any={};
listCategotyComplains:any=[];
listSubCategotyComplains:any=[];
category:any="";
subcomplain:any="";
ccs_remarks:any="";
  constructor(
private loadingCtrl: LoadingController,
    public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  
    this.category="0";
    this.subcomplain="0";
  }

  ionViewDidLoad() {
    ////console.log('ionViewDidLoad CommingSoonPage');
    this.getCasetypesComplaint()
  }
  presentActionSheet(msg) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: 'Ok',
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
             this.navCtrl.setRoot(HomePage);
          }
        }
      ]
    });
    actionSheet.present();
  }

  getCasetypesComplaint(){
    let loading = this.loadingCtrl.create({
              content: 'Please wait...'
            });
    loading.present()
      this.cp.getCasetypesComplaint(loading,'CC02').then((res:any)=>{
        // ////console.log("caseTpe",res)
        loading.dismiss();
        var res=JSON.parse(res)
        this.listCategotyComplains = res.Payload.casetypes;
      }).catch((err:any)=>{
        ////console.log(err)
      })
    }

    getSubCasetypesComplaint(ifhl_catcode){
       let loading = this.loadingCtrl.create({
              content: 'Please wait...'
            });
    loading.present()
      this.cp.getSubCasetypesComplaint(loading,ifhl_catcode).then((res:any)=>{
        loading.dismiss();
         var res=JSON.parse(res)
        this.listSubCategotyComplains = res.Payload.casesubtypes;
      }).catch((err:any)=>{
        ////console.log(err)
      })
    }
  postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    ////console.log(this.errorDisplay)
    if(this.errorDisplay.valid){
     return false;
   }else if(this.category=="" || this.category=="0"){
    this.errorDisplay.category="Please select category";
    return false;
    }else if(this.subcomplain=="" || this.subcomplain=="0"){
      this.errorDisplay.Sub_category="Please select sub category";
      return false;
    }
  else{
      var ccs_casecategory="CC02";;
      var ccs_casetype=this.category;
      var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
      var ccs_originatingsource="S01"
      var ccs_casesubtype = this.subcomplain;
      var ccs_remarks = this.ccs_remarks;
      let loading = this.loadingCtrl.create({
                content: 'Please wait...'
              });
      loading.present()
      this.cp.postRaiseQuery(loading,ccs_casecategory,ccs_remarks,
                             "404276",ccs_casetype,
                             ibhfl_loanaccountnumber1,
                             ccs_originatingsource,
                             ccs_casesubtype).then((res:any)=>{
                              loading.dismiss()
                              var res=JSON.parse(res);
                              ////console.log(res);
                              this.presentActionSheet("Your SR No. "+res.Payload.caseid+" has been initiated.")
                             })
     
     }
   }
}



// WEBPACK FOOTER //
// ./src/pages/comming-soon/comming-soon.ts